import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import {MenuHomeEnum} from 'app/home';

@Injectable({
    providedIn: 'root',
})
export class MenuService {

    private menuHomeEnumActive = new BehaviorSubject<MenuHomeEnum>(MenuHomeEnum.CebuanaPayout);
    menuHomeEnumActive$ = this.menuHomeEnumActive.asObservable();

    constructor() {
    }

    changeMenuHomeEnumActive(value: MenuHomeEnum) {
        this.menuHomeEnumActive.next(value);
    }

    getMenuHomeEnumActive() {
        return this.menuHomeEnumActive.value;
    }
}
